import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type { LocationReq, LocationRes } from './types';

const getLocationCoords = async (
  address: LocationReq
): Promise<LocationRes | null> => {
  return axios<
    LocationRes,
    BaseResponse<LocationRes, LocationReq>,
    LocationReq
  >({
    url: '/customers/coordinates',
    method: 'post',
    data: address,
  }).then((res) => res?.data.data);
};

export const useLocationCoords = () => {
  const { mutateAsync, isLoading, error } = useMutation(getLocationCoords);

  useEffect(() => {
    displayError(error);
  }, [error]);

  return {
    getLocationCoords: mutateAsync,
    isLoading,
  };
};
